import React from 'react';
import Modal from '../../core/Modal';

const ModalForgetPassword = ({ clickCloseIcon }) => (
  <Modal title="Restablecer contraseña" clickCloseIcon={clickCloseIcon}>
    <p>
      Si has olvidado tu contraseña, ponte en contacto con el CAU (extensión
      <strong> 66001-916232454</strong>).
    </p>
    <p>
      Si tu contraseña ha caducado, sigue el enlace para{' '}
      <a
        href="https://atresmail.atresmedia.com/owa/auth/logon.aspx?url=https%3a%2f%2fatresmail.atresmedia.com%2fowa%2f&amp;reason=3"
        target="_blank"
        rel="noopener noreferrer"
      >
        renovar la contraseña
      </a>
      .
    </p>
  </Modal>
);

export default ModalForgetPassword;
